var accordion = (function() {

    var $accordion = $('.js-accordion');
    var $accordion_header = $accordion.find('.js-accordion-header');
    // var $accordion_item = $('.accordion-item');

    // default settings 
    var settings = {
        // animation speed
        speed: 400,

        // close all other accordion items if true
        oneOpen: false
    };

    return {
        // pass configurable object literal
        init: function($settings) {
            $accordion_header.on('click', function() {
                accordion.toggle($(this));
            });

            $.extend(settings, $settings);

            // ensure only one accordion is active if oneOpen is true
            if (settings.oneOpen && $('.accordion-item.active').length > 1) {
                $('.accordion-item.active:not(:first)').removeClass('active');
            }

            // reveal the active accordion bodies
            $('.accordion-item.active').find('> .js-accordion-body').show();
        },
        toggle: function($this) {

            if (settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .accordion-item.active > .js-accordion-header')[0]) {
                $this.closest('.js-accordion')
                    .find('> .accordion-item')
                    .removeClass('active')
                    .find('.js-accordion-body')
                    .slideUp()
            }

            // show/hide the clicked accordion item
            $this.closest('.accordion-item').toggleClass('active');
            $this.next().stop().slideToggle(settings.speed);
        }
    }
})();

jQuery(document).ready(function($) {
    accordion.init({ speed: 300, oneOpen: true });
    const $waveTypeSelector = $('select#waveSelected');
    const $waveForm = $('#the-wave');
    const $waveSelectedOption = $('#waveSelected');
    const $wandTypeSelector = $('select#wandSelected');
    const $wandForm = $('#the-wand');
    const $wandSelectedOption = $('#wandSelected');

    $waveTypeSelector.change(e => {
        $(`.purchase [data-id="${$( e.currentTarget ).val()}"]`).trigger('click');
    });
    $wandTypeSelector.change(e => {
        $(`.purchase [data-id="${$( e.currentTarget ).val()}"]`).trigger('click');
    });

    $($waveForm).on('submit', e => {
        e.preventDefault();
        const productID = $waveSelectedOption.on('change').val();
        window.location = `https://shop.drinkpurewine.com/cart/add?id=${productID}`;
    });

    $($wandForm).on('submit', e => {
        e.preventDefault();
        const productID = $wandSelectedOption.on('change').val();
        window.location = `https://shop.drinkpurewine.com/cart/add?id=${productID}`;
    });

    //  Mobile Navigation

    // Social Proof
    // $('.logo-slider').slick({
    //     arrows: false,
    //     infinite: true,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     speed: 1000,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     responsive: [{
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 1,
    //                 infinite: true,
    //                 dots: false,
    //             },
    //         }, {
    //             breakpoint: 767,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 3,
    //                 infinite: true,
    //                 dots: false,
    //             },
    //         }, {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 2,
    //                 infinite: true,
    //                 dots: false,
    //             },
    //         }, {
    //             breakpoint: 375,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 1,
    //                 infinite: true,
    //                 dots: false,
    //             },
    //         },

    //         // You can unslick at a given breakpoint now by adding:
    //         // settings: "unslick"
    //         // instead of a settings object,,,,,,,
    //     ],
    // });

    // $('.testimonial-slider').slick({
    //     dots: true,
    //     arrows: false,
    //     infinite: true,
    //     centerMode: true,
    //     speed: 1000,
    //     autoplay: true,
    //     autoplaySpeed: 4000,
    //     slidesToShow: 3,
    //     slidesToScroll: 2,
    //     pauseOnHover: false,
    //     responsive: [{
    //         breakpoint: 1200,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             centerMode: true,
    //             infinite: true,
    //             dots: false,
    //             arrows: false,
    //         },
    //     }, {
    //         breakpoint: 601,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             centerMode: true,
    //             arrows: false,
    //         },
    //     }, {
    //         breakpoint: 375,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             arrows: false,
    //             centerMode: true,
    //         },
    //     }, {
    //         breakpoint: 0,
    //         settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             arrows: false,
    //         },
    //     }, ],
    // });

    const scroll = new SmoothScroll('a[href*="#"]', {
        offset: 90,
        speed: 800,
    });

    // Wheel Click Modal
    $('button.btn-prime').on('mousedown', e => {
        if (e.which === 2) {
            e.preventDefault();
            e.stopPropagation();
            $(e.currentTarget).trigger('click');
        }
    });

    $(window).on('scroll', () => {
        if ($(window).width() > 992) {
            if ($(window).scrollTop() > 700) {
                console.log("scrolled");
                $('.stickyMenu').addClass('menu-show');
            } else {
                // remove the background property so it comes transparent again (defined in your css)
                $('.stickyMenu').removeClass('menu-show');
            }
        }
    });

    $('.about-slide').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    });

    // Auto update the cart
    $('.cart__product-qty').on('blur', function() {
        $(".cart__update").trigger("click");
    });

    $('.cart__update').on('click', function() {
        $(".cart__checkout").prop('disabled', true);
    });


    /* 
Copyright (c) 2021 by Guillaume Briand (https://codepen.io/C2P0/pen/EaPBWe)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
    // $('.sidebar').fixedsticky();

    /*!
Copyright (c) 2021 by manish (https://codepen.io/manishfoodtechs/pen/abNBjwb)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
    document.addEventListener('click', function(e) {
        e = e || window.event;
        var target = e.target || e.srcElement;

        if (target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') == 'modal') {
            if (target.hasAttribute('data-target')) {
                var m_ID = target.getAttribute('data-target');
                document.getElementById(m_ID).classList.add('open');
                e.preventDefault();
            }
        }

        // Close modal window with 'data-dismiss' attribute or when the backdrop is clicked
        //   if ((target.hasAttribute('data-dismiss') && target.getAttribute('data-dismiss') == 'modal') || target.classList.contains('modal')) {
        //     var modal = document.querySelector('[class="modal open"]');
        //     modal.classList.remove('open');
        //     e.preventDefault();
        //   }
    }, false);
});